import api from './api';
import { ApiResponse, unwrapApiResponse } from '@/utils/api-response.util';

// Відповідь для завантаження аватара
interface AvatarUploadResponse {
  path: string;
  user: { id: number; avatar: string };
}

// Структура об'єкта файлу з backend
export interface ApiFile {
  id: number;
  originalFilename: string;
  url: string;
  size: number;
  mimeType: string;
  fileType: 'image' | 'document' | 'other';
  comment: string | null;
  createdAt: any;
}

export interface GetFilesResponse {
  files: ApiFile[];
  total: number;
}

export interface GetFilesParams {
  type?: 'image' | 'document' | 'other';
  search?: string;
  limit?: number;
  offset?: number;
}

class FileService {
  async uploadAvatar(file: File): Promise<AvatarUploadResponse> {
    const formData = new FormData();
    formData.append('file', file);

    const response = await api.post<ApiResponse<AvatarUploadResponse>>('/files/avatar', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return unwrapApiResponse<AvatarUploadResponse>(response);
  }

  async uploadFile(file: File, comment?: string, source?: 'manager' | 'chat'): Promise<ApiFile> {
    const formData = new FormData();
    formData.append('file', file);
    if (comment) {
      formData.append('comment', comment);
    }
    if (source) {
      formData.append('source', source);
    }

    const response = await api.post<ApiResponse<ApiFile>>('/files/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return unwrapApiResponse<ApiFile>(response);
  }

  async getFiles(params: GetFilesParams): Promise<GetFilesResponse> {
    const response = await api.get<ApiResponse<ApiFile[]>>('/files', { params });
    const files = unwrapApiResponse<ApiFile[]>(response);

    return {
      files: files,
      total: files.length,
    };
  }

  async getClientFiles(clientId: string, params: GetFilesParams): Promise<GetFilesResponse> {
    const response = await api.get<ApiResponse<ApiFile[]>>(`/client/${clientId}/files`, { params });
    const files = unwrapApiResponse<ApiFile[]>(response);
    return {
        files: files,
        total: files.length,
    };
  }

  async downloadFileBlob(url: string): Promise<Blob> {
    const response = await api.get<Blob>(url, {
      responseType: 'blob',
    });
    return response.data;
  }

  async deleteFile(id: number): Promise<{ message: string }> {
    const response = await api.delete<ApiResponse<{ message: string }>>(`/files/${id}`);
    return unwrapApiResponse<{ message: string }>(response);
  }

  async updateFileComment(id: number, comment: string | null): Promise<ApiFile> {
    const response = await api.patch<ApiResponse<ApiFile>>(`/files/${id}/comment`, { comment });
    return unwrapApiResponse<ApiFile>(response);
  }
}

export const fileService = new FileService();
